import { Component, Input } from '@angular/core';
import { ContainerSize } from '@freelancer/ui/container';

@Component({
  selector: 'app-navigation-secondary-portfolio',
  template: `
    <app-bar
      i18n-appBarTitle="Secondary navigation my profile bar title"
      appBarTitle="My Profile »"
      link="/me"
      flTrackingSection="SubnavProfile"
      [containerSize]="containerSize"
    >
      <app-bar-item
        link="/me"
        i18n="Secondary navigation profile bar item"
        flTrackingLabel="ImproveProfile"
        [linkIsActive]="false"
      >
        Improve Profile
      </app-bar-item>
      <app-bar-item
        link="/discover/manage"
        i18n="Secondary navigation portfolio bar item"
        [flTrackingLabel]="'Portfolio'"
        [linkIsActive]="true"
      >
        Portfolios
      </app-bar-item>
      <!--
      <app-bar-item
        link="#"
        i18n="Secondary navigation collections bar item"
        [flTrackingLabel]="'Collections'"
        [linkIsActive]="false"
      >
        Collections
      </app-bar-item>
      -->
      <app-bar-item
        link="/services/dashboard.php"
        i18n="Secondary navigation services bar item"
        flTrackingLabel="MyServices"
        [linkIsActive]="false"
      >
        My Services
      </app-bar-item>
      <app-bar-item
        link="/exam/exams/index.php"
        i18n="Secondary navigation certification bar item"
        flTrackingLabel="GetCertified"
        [linkIsActive]="false"
      >
        Get Certified
      </app-bar-item>
      <app-bar-item
        link="/hireme-widget-builder/"
        i18n="Secondary navigation promote profile bar item"
        flTrackingLabel="PromoteProfile"
        [linkIsActive]="false"
      >
        Promote Profile
      </app-bar-item>
      <app-bar-item
        link="/users/game/"
        i18n="Secondary navigation my rewards bar item"
        flTrackingLabel="MyRewards"
        [linkIsActive]="false"
      >
        My Rewards
      </app-bar-item>
    </app-bar>
  `,
})
export class NavigationSecondaryPortfolioComponent {
  @Input() containerSize: ContainerSize;
}
